import * as cartActionTypes from "./actions/cart/actionTypes"
import { UPDATE_USER } from "./actions/userActions"

const initCart: Cart = {
  items: [],
  quantity: 0,
  totalAmount: 0
}

// Helper to get price from product (supports both price and unitPrice)
const getProductPrice = (product: Product): number => {
  return product.price || product.unitPrice || 0
}

const cart = (state: Cart = initCart, action: CartAction): Cart => {
  switch (action.type) {
    case cartActionTypes.ADD_TO_CART:
      const addedProduct = action.payload as Product
      const productPrice = getProductPrice(addedProduct)
      const updatedCart: Cart = {
        ...state,
        items: state.items.map(item => {
          if (item.product.name === addedProduct.name) {
            return { ...item, quantity: item.quantity + 1 }
          } else {
            return { ...item }
          }
        }),
      }

      // if item not yet in cart
      if (!state.items.some(item => item.product.name === addedProduct.name)) {
        updatedCart.items.push({ 
          product: addedProduct, 
          quantity: 1, 
          totalPrice: productPrice
        })
      }

      // calculate totals
      updatedCart.items.forEach(item => item.totalPrice = item.quantity * getProductPrice(item.product))
      updatedCart.quantity = updatedCart.items.map(item => item.quantity).reduce((a, b) => a + b, 0)
      updatedCart.totalAmount = updatedCart.items.map(items => items.totalPrice).reduce((a, b) => a + b, 0)
      
      return updatedCart
    case cartActionTypes.CLEAR_CART:
      return initCart
    case cartActionTypes.REMOVE_FROM_CART:
      const removeProduct = action.payload as Product
      const filteredItems = state.items.filter(item => item.product.name !== removeProduct.name)
      const updatedCartRemove: Cart = {
        ...state,
        items: filteredItems
      }
      updatedCartRemove.quantity = updatedCartRemove.items.map(item => item.quantity).reduce((a, b) => a + b, 0)
      updatedCartRemove.totalAmount = updatedCartRemove.items.map(items => items.totalPrice).reduce((a, b) => a + b, 0)
      return updatedCartRemove
    case cartActionTypes.UPDATE_QUANTITY:
      const updatePayload = action.payload as { product: Product; quantity: number }
      const { product, quantity } = updatePayload
      if (quantity <= 0) {
        const filteredItemsQty = state.items.filter(item => item.product.name !== product.name)
        const updatedCartQty: Cart = {
          ...state,
          items: filteredItemsQty
        }
        updatedCartQty.quantity = updatedCartQty.items.map(item => item.quantity).reduce((a, b) => a + b, 0)
        updatedCartQty.totalAmount = updatedCartQty.items.map(items => items.totalPrice).reduce((a, b) => a + b, 0)
        return updatedCartQty
      }
      const updatedItems = state.items.map(item => 
        item.product.name === product.name 
          ? { ...item, quantity: quantity, totalPrice: quantity * getProductPrice(item.product) }
          : item
      )
      const updatedCartNewQty: Cart = {
        ...state,
        items: updatedItems
      }
      updatedCartNewQty.quantity = updatedCartNewQty.items.map(item => item.quantity).reduce((a, b) => a + b, 0)
      updatedCartNewQty.totalAmount = updatedCartNewQty.items.map(items => items.totalPrice).reduce((a, b) => a + b, 0)
      return updatedCartNewQty
    default:
      return state
  }
}

const defaultUser: User = {
  firstName: '',
  lastName: '',
  email: ''
}
const currentUser = (state: User = defaultUser, action: any): User => {
  switch (action.type) {
    case UPDATE_USER:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export { cart, currentUser }